'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _reactRouter = require('react-router');

var _constants = require('../../constants');

var _util = require('../../utils/util');

var _common = require('../common');

var _pageContacts = require('../page-contacts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var MODEL_TYPES = _constants.AppConstants.MODEL_TYPES;
var ContactListPage = (_dec = (0, _mobxReact.inject)('Clients', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(ContactListPage, _Component);

  function ContactListPage(props) {
    _classCallCheck(this, ContactListPage);

    var _this = _possibleConstructorReturn(this, (ContactListPage.__proto__ || Object.getPrototypeOf(ContactListPage)).call(this, props));

    _this.isMedical = props.route.isMedical;
    _this.pageStore = props.UiStore.contactListPage;
    return _this;
  }

  _createClass(ContactListPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var query = this.props.location.query,
          ordering = query.ordering && (0, _util.unformatSortingParams)(query.ordering),
          filters = (0, _omit3.default)(query, ['ordering', 'search']),
          defaultOrdering = [{ desc: false, id: 'first_name' }];

      // limit types filtered for backwards compatibility
      if (this.isMedical) {
        filters.type = MODEL_TYPES.medicalFacilityContact.key + ',' + MODEL_TYPES.medicalProvider.key;
      } else {
        filters.type = MODEL_TYPES.attorney.key + ',' + MODEL_TYPES.contact.key;
      }

      this.pageStore.ordering = ordering || defaultOrdering;
      this.pageStore.filters = filters;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleFilterChange({ onInitialPageLoad: true });
    }
  }, {
    key: 'changeFilters',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var onQueryReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.pageStore.loading = true;
                _context.next = 3;
                return this.handleFilterChange({ onQueryReset: onQueryReset });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function changeFilters() {
        return _ref.apply(this, arguments);
      }

      return changeFilters;
    }()
  }, {
    key: 'handleFilterChange',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$onInitialPageLo = _ref3.onInitialPageLoad,
            onInitialPageLoad = _ref3$onInitialPageLo === undefined ? false : _ref3$onInitialPageLo,
            _ref3$onQueryReset = _ref3.onQueryReset,
            onQueryReset = _ref3$onQueryReset === undefined ? false : _ref3$onQueryReset;

        var location, pathname, query, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                location = this.props.location, pathname = location.pathname, query = this.pageStore.query;


                _reactRouter.browserHistory.push({ pathname: pathname, query: query });
                _context2.next = 4;
                return this.peopleClient.list({ params: query });

              case 4:
                data = _context2.sent;


                this.trackFilterChangeEvent(onInitialPageLoad, onQueryReset);

                this.pageStore.tableData = data.results;
                this.pageStore.nextPageURL = data.next;
                this.pageStore.loading = false;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleFilterChange() {
        return _ref2.apply(this, arguments);
      }

      return handleFilterChange;
    }()
  }, {
    key: 'trackFilterChangeEvent',
    value: function trackFilterChangeEvent(onInitialPageLoad, onQueryReset) {
      var SessionStore = this.props.SessionStore,
          eventName = 'CONTACT_LIST_QUERY_CHANGE',
          eventData = _extends({
        on_initial_page_load: onInitialPageLoad,
        on_query_reset: onQueryReset
      }, this.pageStore.queryToLog);

      SessionStore.trackEvent(eventName, eventData);
    }
  }, {
    key: 'onLoadMoreClick',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.pageStore.loading = true;
                _context3.next = 3;
                return this.peopleClient.loadMore(this.pageStore.nextPageURL);

              case 3:
                data = _context3.sent;

                this.pageStore.tableData = this.pageStore.tableData.concat(data.results);
                this.pageStore.nextPageURL = data.next;
                this.pageStore.loading = false;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onLoadMoreClick() {
        return _ref4.apply(this, arguments);
      }

      return onLoadMoreClick;
    }()
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _common.Page,
        { name: 'contacts', type: 'list', hasSidebar: true },
        _react2.default.createElement(_reactHelmet2.default, { title: 'People' }),
        _react2.default.createElement(
          _common.Page.Sidebar,
          null,
          _react2.default.createElement(_pageContacts.ContactListSidebar, {
            changeFilters: this.changeFilters,
            entityName: this.isMedical ? 'Provider' : 'Attorney'
          })
        ),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          _react2.default.createElement(_common.BaseList, {
            columns: this.tableColumns,
            handleSort: this.changeFilters,
            onLoadMoreClick: this.onLoadMoreClick,
            pageStore: this.pageStore,
            title: this.isMedical ? 'Providers' : 'Attorneys',
            entityType: 'contacts'
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'peopleClient',
    get: function get() {
      var Clients = this.props.Clients;


      return Clients.people;
    }
  }, {
    key: 'tableColumns',
    get: function get() {
      if (this.isMedical) {
        return _pageContacts.CONTACT_COLUMNS.filter(function (column) {
          return !column.isLegalOnly;
        });
      }

      return _pageContacts.CONTACT_COLUMNS.filter(function (column) {
        return !column.isMedicalOnly;
      });
    }
  }]);

  return ContactListPage;
}(_react.Component), _class3.propTypes = {
  Clients: _propTypes2.default.object,
  location: _propTypes2.default.object.isRequired,
  route: _propTypes2.default.object,
  SessionStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'changeFilters', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'changeFilters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleFilterChange', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleFilterChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onLoadMoreClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onLoadMoreClick'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = ContactListPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MODEL_TYPES, 'MODEL_TYPES', '/app/src/components/pages/ContactListPage.js');
  reactHotLoader.register(ContactListPage, 'ContactListPage', '/app/src/components/pages/ContactListPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/pages/ContactListPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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